import ChaCha from '@/statics/chacha20.js';

export default function Messaging(logger)
{

    this._protocolVersion = 1;
    this._keySize = 32;
    this._nonceSize = 8;
    this._headerLength = 17;

    //Header structure
    this._HEADER_PROTOCOL_VERSION_STARTING_BYTE = 0,
    this._HEADER_SOURCE_UUID_STARTING_BYTE = 1,
    this._HEADER_DESTINATION_UUID_STARTING_BYTE = 5,
    this._HEADER_NONCE_STARTING_BYTE = 9,
    this._HEADER_DATESTAMP_STARTING_BYTE = 9,
    this._HEADER_TIMESTAMP_STARTING_BYTE = 13,

    //Body structure
    this._BODY_CHECKSUM_STARTING_BYTE = 0 + this._headerLength;
    this._BODY_CHECKSUM_CALCULATION_STARTING_BYTE = 2 + this._headerLength;
    this._BODY_PACKET_TYPE_STARTING_BYTE = 2 + this._headerLength;
    this._BODY_MESSAGE_BODY_STARTING_BYTE = 3 + this._headerLength;

    //Message types
    this.UPLINK_PACKET_FAILURE = 1;
    this.UPLINK_PACKET_TIME_NOT_SET = 2;
    this.UPLINK_PACKET_NOT_PRIVILEGED = 3;
    this.UPLINK_PACKET_SUCCESS = 4;
    this.UPLINK_PACKET_USER_LOGIN = 5;
    this.UPLINK_PACKET_TAKE_OWNERSHIP = 6;
    this.UPLINK_PACKET_SET_HUB_TIME = 7;
    this.UPLINK_PACKET_SEND_COMMAND = 8;
    this.UPLINK_PACKET_HEY_LUXIN = 9;
    //todo: change it to 'add' new user
    this.UPLINK_PACKET_NEW_USER = 10;
    this.UPLINK_PACKET_REMOVE_USER = 11;
    this.UPLINK_PACKET_WIFI_SCAN = 12;
    this.UPLINK_PACKET_WIFI_CONFIG = 13;
    this.UPLINK_PACKET_REGISTER_NODE = 14;
    this.UPLINK_PACKET_PAIR_NODE = 15;
    this.UPLINK_PACKET_REMOVE_NODE = 16;
    this.UPLINK_PACKET_OTA_UPDATE_COMMAND = 17;
    this.UPLINK_PACKET_GET_WARNINGS_REQUEST = 18;
    this.UPLINK_PACKET_UPDATE_PSK_REQUES = 19;
    this.UPLINK_PACKET_SET_NODE_INSTRUCTIONS = 20;
    this.UPLINK_PACKET_SET_HUB_INSTRUCTIONS = 21;
    this.UPLINK_PACKET_READ_NODE_INSTRUCTIONS = 22;
    this.UPLINK_PACKET_READ_NODE_PARAMETERS = 23;
    this.UPLINK_PACKET_READ_HUB_INSTRUCTIONS = 24;
    this.UPLINK_PACKET_READ_HUB_SCHEDULES = 25;
    this.UPLINK_PACKET_READ_HUB_PARAMETERS = 26;
    this.UPLINK_PACKET_GET_NODES_LIST = 27;
    this.UPLINK_PACKET_SET_HUB_SCHEDULES = 28;
    this.UPLINK_PACKET_CHANGE_PASSWORD = 29;
    this.UPLINK_PACKET_GET_USERS_LIST = 30;
    this.UPLINK_PACKET_SET_PARAMETER_WATCHES = 31;
    this.UPLINK_PACKET_READ_PARAMETER_WATCHES = 32;
    this.UPLINK_PACKET_SET_EVENT_MASKS = 33;
    this.UPLINK_PACKET_GET_EVENT_MASKS = 34;
    this.UPLINK_PACKET_SET_UPLINK_IMITATORS = 35;
    this.UPLINK_PACKET_GET_UPLINK_IMITATORS = 36;
    this.UPLINK_PACKET_MODIFY_PARAMETER_WATCHES = 37;
    this.UPLINK_PACKET_MODIFY_HUB_INSTRUCTIONS = 38;
    this.UPLINK_PACKET_DELETE_HUB_INSTRUCTIONS_BY_EVENT_ID = 39;
    this.UPLINK_PACKET_SET_EVENT_NOTIFICATIONS = 40;
    this.UPLINK_PACKET_READ_EVENT_NOTIFICATIONS = 41;
    this.UPLINK_PACKET_MODIFY_UPLINK_IMITATORS = 42;
    this.UPLINK_PACKET_DELETE_UPLINK_IMITATORS_BY_EVENT_ID = 43;
    this.UPLINK_PACKET_GET_EVENT_IDS = 44;
    this.UPLINK_PACKET_GET_HUB_INSTRUCTIONS_BY_ID = 45;
    this.UPLINK_PACKET_GET_UPLINK_IMITATORS_BY_ID = 46;

    this.PARAM_ID_LENGTH_MASK = 0x0700;

    this._encryptionPSK = null;


    this.init = function (messagingContex) {
        this.setEncryptionPSK(messagingContex.psk);
        this.setMessageDestination(messagingContex.destinationUUID,);
        this.setMessageSource(messagingContex.sourceUUID);
    }
    
    this.setEncryptionPSK = function(newPSK)
    {
        logger.log("Messaging.setEncryptionPSK() :", "setting new encryptionPSK to " + newPSK);

        this._encryptionPSK = newPSK;
    }

    this.setMessageDestination = function(newDest)
    {
        logger.log("Messaging.setMessageDestination() :", "setting new message destination to " + newDest);

        this._messageDestination = newDest;
    }

    this.setMessageSource = function(newSource)
    {
        logger.log("Messaging.setMessageSource() :", "setting new message source to " + newSource);

        this._messageSource = newSource;
    }


    this.getDateTimeStamp = function()
    {
        var epochTime = Date.now();
        var dateStamp = Math.floor(epochTime / 86400000);
        var timeStamp = epochTime % 86400000;

        logger.log("Messaging.getDateTimeStamp() :", "calculating dateTimestamp -> dateStamp: " + dateStamp + " ,timeStamp: " + timeStamp + " ,epoch: " + epochTime);

        return {date: dateStamp, time: timeStamp};
    }.bind(this);


    this._addChecksumToSerializedMessageArray = function(serializedMessageArray)
    {
        var checksum = 0;
        for(var i = this._BODY_CHECKSUM_CALCULATION_STARTING_BYTE; i < serializedMessageArray.length; i++){
            checksum += serializedMessageArray[i];
        }
        var checksumLittleEndianArray = this.utility.uint16ToLittleEndianUint8(checksum);
        serializedMessageArray[this._BODY_CHECKSUM_STARTING_BYTE] = checksumLittleEndianArray[0];
        serializedMessageArray[this._BODY_CHECKSUM_STARTING_BYTE + 1] = checksumLittleEndianArray[1];

        logger.log("Messaging.calculateChecksum() :", "calculating checksum : " + checksum);

        return checksum;
    }.bind(this);


    this._encryptMessage = function(messageUint8Array, psk, nonce)
    {
        logger.log("Messaging._encryptMessage() :", "encrypting message with nonce: " + nonce);

        var i,j,curIndex = 0;
        psk = Uint8Array.from(psk);
        var cipher = new ChaCha(psk.buffer, nonce.buffer);
        var block = null;

        for(i = 0; i < Math.ceil((messageUint8Array.length - this._headerLength)/64); i++){
            block = new Uint8Array(cipher());
            for(j = 0; j < 64; j++){
                curIndex = i*64 + j + this._headerLength;
                if(curIndex >= messageUint8Array.length){
                    break;
                }
                messageUint8Array[curIndex] = messageUint8Array[curIndex] ^ block[j];
            }
        }
        logger.log(messageUint8Array, "encrypted message");
    }.bind(this);


    this._base64Encode = function(messageUint8Array)
    {
        logger.log("Messaging._base64Encode() :", "calculating base64 of message:");

        var messageBinaryString = '';

        for(var i = 0; i < messageUint8Array.length; i++){
            messageBinaryString += String.fromCharCode(messageUint8Array[i]);
        }

        var b64encodedMessage = btoa(messageBinaryString);
        //url safe base64
        b64encodedMessage = b64encodedMessage.replace(/\//g, '_');
        b64encodedMessage = b64encodedMessage.replace(/\+/g, '-');
        b64encodedMessage = b64encodedMessage.replace(/=/g, '.');
        logger.log(b64encodedMessage, "b64 of encrypted message");

        return b64encodedMessage;
    }.bind(this);


    this._base64Decode = function(base64EncodedMessage)
    {
        logger.log("Messaging._base64Decode() :", "base64 decoding message:");

        //un url safe base64
        base64EncodedMessage = base64EncodedMessage.replace(/_/g, '/');
        base64EncodedMessage = base64EncodedMessage.replace(/-/g, '+');
        base64EncodedMessage = base64EncodedMessage.replace(/\./g, '=');

        var encryptedMessageArray = new Uint8Array(atob(base64EncodedMessage).split("").map(function(c)
        {
            return c.charCodeAt(0); 
        }));

        logger.log(encryptedMessageArray, "decoded array of encrypted message");

        return encryptedMessageArray;
    }.bind(this);


    this._serializeMessage = function(messageObject, serializerFunction)
    {
        var serializedMessageArray = [];

        //adding protocol version to byte 0
        serializedMessageArray.push( messageObject.header.protocolVersion );
        //adding user uuid to bytes 1 to 4
        var sourceLittleEndian = this.utility.uint32ToLittleEndianUint8(messageObject.header.source);
        serializedMessageArray.push( sourceLittleEndian[0] );
        serializedMessageArray.push( sourceLittleEndian[1] );
        serializedMessageArray.push( sourceLittleEndian[2] );
        serializedMessageArray.push( sourceLittleEndian[3] );
        //adding hub uuid to bytes 5 to 9
        var destLittleEndian = this.utility.uint32ToLittleEndianUint8(messageObject.header.destination);
        serializedMessageArray.push( destLittleEndian[0] );
        serializedMessageArray.push( destLittleEndian[1] );
        serializedMessageArray.push( destLittleEndian[2] );
        serializedMessageArray.push( destLittleEndian[3] );
        //adding datestamp to bytes 10 to 13
        var dateLittleEndian = this.utility.uint32ToLittleEndianUint8(messageObject.header.nonce.dateStamp);
        serializedMessageArray.push( dateLittleEndian[0] );
        serializedMessageArray.push( dateLittleEndian[1] );
        serializedMessageArray.push( dateLittleEndian[2] );
        serializedMessageArray.push( dateLittleEndian[3] );
        //adding timestamp to bytes 14 to 17
        var timeLittleEndian = this.utility.uint32ToLittleEndianUint8(messageObject.header.nonce.timeStamp);
        serializedMessageArray.push( timeLittleEndian[0] );
        serializedMessageArray.push( timeLittleEndian[1] );
        serializedMessageArray.push( timeLittleEndian[2] );
        serializedMessageArray.push( timeLittleEndian[3] );
        //adding two bytes dummy checksum
        serializedMessageArray.push( 0 );
        serializedMessageArray.push( 0 );
        //adding message type
        serializedMessageArray.push( messageObject.body.messageType );
    
        serializerFunction(serializedMessageArray, messageObject.body.bodyContent);

        return serializedMessageArray;
    }.bind(this);


    this._serializeMessage_number = function(messageArray, number){
        logger.log("Messaging._serializeMessage_number() :", "serializing number");

        messageArray.push(number);
    }.bind(this);


    this._serializeMessage_string = function(messageArray, string){
        logger.log("Messaging._serializeMessage_string() :", "serializing string");

        for(var i = 0; i < 32; i++){
            if(i < string.length){
                messageArray.push( string.charCodeAt(i) );
            }else{
                messageArray.push( 0x00 );
            }
        }
    }.bind(this);


    this._serializeMessage_array = function(messageArray, array)
    {
        logger.log("Messaging._serializeMessage_array() :", "serializing array");

        for(var i = 0; i < array.length; i++){
            messageArray.push(array[i]);
        }
    }.bind(this);


    this._serializeMessage_parameter_value = function(messageArray, parameterId, parameterValue)
    {
        var parameterLength = this.utility.resolveParameterLength(parameterId);
        //todo: add other cases
        switch(parameterLength){
            case 1:
                this._serializeMessage_number(messageArray, parameterValue);
                break;
            case 2:
                this._serializeMessage_array(messageArray, this.utility.uint16ToLittleEndianUint8(parameterValue));
                break;
            case 4:
                this._serializeMessage_array(messageArray, this.utility.uint32ToLittleEndianUint8(parameterValue));
                break;
            case 64:
                this._serializeMessage_array(messageArray, parameterValue);
                break;
            case 128:
                this._serializeMessage_array(messageArray, parameterValue);
                break;
            default:
                logger.log("Messaging._serializeMessage_parameter_value()", "case default, parameter length: " + parameterLength);
            break;
        }
    }.bind(this);


    this.createHubMessage = function(messageContextObject)
    {
        logger.log("Messaging.createHubMessage() :", "creating a hub message encrypted message");

        var messageType = messageContextObject.messageType;
        var messageSerializerFunction = null;

        switch(messageType){
            case this.UPLINK_PACKET_TAKE_OWNERSHIP:
                logger.log("Messaging.sendMessageToHub() :", "creating take ownership of hub encrypted message");
                messageSerializerFunction = this._takeOwnershipOfHubSerializer;
                break;
            case this.UPLINK_PACKET_SET_HUB_TIME:
                logger.log("Messaging.sendMessageToHub() :", "creating set hub dateTime encrypted message");
                messageSerializerFunction = this._setHubDateTimeSerializer;
                break;
            case this.UPLINK_PACKET_REGISTER_NODE:
                logger.log("Messaging.sendMessageToHub() :", "creating register new node encrypted message");
                messageSerializerFunction = this._registerNewNodeSerializer;
                break;
            case this.UPLINK_PACKET_REMOVE_NODE:
                logger.log("Messaging.sendMessageToHub() :", "creating delete node encrypted message");
                messageSerializerFunction = this._deleteNodeSerializer;
                break;
            case this.UPLINK_PACKET_PAIR_NODE:
                logger.log("Messaging.sendMessageToHub() :", "creating pair node encrypted message");
                messageSerializerFunction = this._pairNodeSerializer;
                break;
            case this.UPLINK_PACKET_SEND_COMMAND:
                logger.log("Messaging.sendMessageToHub() :", "creating set parameters of nodes encrypted message");
                messageSerializerFunction = this._setParametersOfNodesSerializer;
                break;
            case this.UPLINK_PACKET_GET_NODES_LIST:
                logger.log("Messaging.sendMessageToHub() :", "creating get node list encrypted message");
                messageSerializerFunction = this._getNodesListSerializer;
                break;
            case this.UPLINK_PACKET_READ_NODE_PARAMETERS:
                logger.log("Messaging.sendMessageToHub() :", "creating get node parameters encrypted message");
                messageSerializerFunction = this._readNodeParametersSerializer;
                break;
            case this.UPLINK_PACKET_WIFI_SCAN:
                logger.log("Messaging.sendMessageToHub() :", "creating get wifi networks encrypted message");
                messageSerializerFunction = this._getWifiNetworksSerializer;
                break;
            case this.UPLINK_PACKET_WIFI_CONFIG:
                logger.log("Messaging.sendMessageToHub() :", "creating get wifi networks encrypted message");
                messageSerializerFunction = this._setHubWifiSerializer;
                break;
            case this.UPLINK_PACKET_READ_NODE_INSTRUCTIONS:
                logger.log("Messaging.sendMessageToHub() :", "creating read instructions encrypted message");
                messageSerializerFunction = this._readInstructionsSerializer;
                break;
            case this.UPLINK_PACKET_SET_NODE_INSTRUCTIONS:
                logger.log("Messaging.sendMessageToHub() :", "creating read instructions encrypted message");
                messageSerializerFunction = this._setInstructionsSerializer;
                break;
            case this.UPLINK_PACKET_NEW_USER:
                logger.log("Messaging.sendMessageToHub() :", "creating add new user encrypted message");
                messageSerializerFunction = this._addNewUserSerializer;
                break;
            case this.UPLINK_PACKET_REMOVE_USER:
                logger.log("Messaging.sendMessageToHub() :", "creating delete user encrypted message");
                messageSerializerFunction = this._deleteUserSerializer;
                break;
            case this.UPLINK_PACKET_CHANGE_PASSWORD:
                logger.log("Messaging.sendMessageToHub() :", "creating change password encrypted message");
                messageSerializerFunction = this._changePasswordSerializer;
                break;
            case this.UPLINK_PACKET_USER_LOGIN:
                logger.log("Messaging.sendMessageToHub() :", "creating user login encrypted message");
                messageSerializerFunction = this._userLoginSerializer;
                break;
            case this.UPLINK_PACKET_READ_HUB_INSTRUCTIONS:
                logger.log("Messaging.sendMessageToHub() :", "creating read hub instructions encrypted message");
                messageSerializerFunction = this._readHubInstructionsSerializer;
                break;
            case this.UPLINK_PACKET_SET_HUB_INSTRUCTIONS:
                logger.log("Messaging.sendMessageToHub() :", "creating set hub instruction message");
                messageSerializerFunction = this._setHubInstructionSerializer;
                break;
            case this.UPLINK_PACKET_READ_HUB_SCHEDULES:
                logger.log("Messaging.sendMessageToHub() :", "creating read hub schedules encrypted message");
                messageSerializerFunction = this._readHubSchedulesSerializer;
                break;
            case this.UPLINK_PACKET_SET_HUB_SCHEDULES:
                logger.log("Messaging.sendMessageToHub() :", "creating set hub schdule message");
                messageSerializerFunction = this._setHubScheduleSerializer;
                break;
            case this.UPLINK_PACKET_READ_HUB_PARAMETERS:
                logger.log("Messaging.sendMessageToHub() :", "creating read hub parameters message");
                messageSerializerFunction = this._readHubParametersSerializer;
                break;
            case this.UPLINK_PACKET_OTA_UPDATE_COMMAND:
                logger.log("Messaging.sendMessageToHub() :", "creating request ota message");
                messageSerializerFunction = this._requestOtaSerializer;
                break;
            case this.UPLINK_PACKET_GET_USERS_LIST:
                logger.log("Messaging.sendMessageToHub() :", "creating get user list message");
                messageSerializerFunction = this._getUserListSerializer;
                break;
            case this.UPLINK_PACKET_READ_PARAMETER_WATCHES:
                logger.log("Messaging.sendMessageToHub() :", "creating read parameter watches message");
                messageSerializerFunction = this._readParameterWatchesSerializer;
                break;
            case this.UPLINK_PACKET_SET_PARAMETER_WATCHES:
                logger.log("Messaging.sendMessageToHub() :", "creating set parameter watches message");
                messageSerializerFunction = this._setParameterWatchesSerializer;
                break;
            case this.UPLINK_PACKET_SET_EVENT_MASKS:
                logger.log("Messaging.sendMessageToHub() :", "creating set event mask message");
                messageSerializerFunction = this._setEventMaskSerializer;
                break;
            case this.UPLINK_PACKET_GET_EVENT_MASKS:
                logger.log("Messaging.sendMessageToHub() :", "creating get event mask message");
                messageSerializerFunction = this._getEventMasksSerializer;
                break;
            case this.UPLINK_PACKET_SET_UPLINK_IMITATORS:
                logger.log("Messaging.sendMessageToHub() :", "creating set uplink imitators message");
                messageSerializerFunction = this._setUplinkImitatorsSerializer;
                break;
            case this.UPLINK_PACKET_GET_UPLINK_IMITATORS:
                logger.log("Messaging.sendMessageToHub() :", "creating get uplink imitators message");
                messageSerializerFunction = this._getUplinkImitatorsSerializer;
                break;
            case this.UPLINK_PACKET_MODIFY_PARAMETER_WATCHES:
                logger.log("Messaging.sendMessageToHub() :", "creating modify parameter watches message");
                messageSerializerFunction = this._modifyParameterWatchesSerializer;
                break;
            case this.UPLINK_PACKET_MODIFY_HUB_INSTRUCTIONS:
                logger.log("Messaging.sendMessageToHub() :", "creating modify hub instructions message");
                messageSerializerFunction = this._modifyHubInstructionsSerializer;
                break;
            case this.UPLINK_PACKET_DELETE_HUB_INSTRUCTIONS_BY_EVENT_ID:
                logger.log("Messaging.sendMessageToHub() :", "creating delete hub instructions by event id message");
                messageSerializerFunction = this._deleteHubInstructionsSerializer;
                break;
            case this.UPLINK_PACKET_SET_EVENT_NOTIFICATIONS:
                logger.log("Messaging.sendMessageToHub() :", "creating set event notifications message");
                messageSerializerFunction = this._setEventNotificationsSerializer;
                break;
            case this.UPLINK_PACKET_READ_EVENT_NOTIFICATIONS:
                logger.log("Messaging.sendMessageToHub() :", "creating read event notifications message");
                messageSerializerFunction = this._readEventNotificationsSerializer;
                break;
            case this.UPLINK_PACKET_MODIFY_UPLINK_IMITATORS:
                logger.log("Messaging.sendMessageToHub() :", "creating modify uplink imitators message");
                messageSerializerFunction = this._modifyUplinkImitatorsSerializer;
                break;
            case this.UPLINK_PACKET_DELETE_UPLINK_IMITATORS_BY_EVENT_ID:
                logger.log("Messaging.sendMessageToHub() :", "creating delete uplink imitators message");
                messageSerializerFunction = this._deleteUplinkImitatorsSerializer;
                break;
            case this.UPLINK_PACKET_GET_EVENT_IDS:
                logger.log("Messaging.sendMessageToHub() :", "creating get event ids message");
                messageSerializerFunction = this._getEventIdsSerializer;
                break;
            case this.UPLINK_PACKET_GET_HUB_INSTRUCTIONS_BY_ID:
                logger.log("Messaging.sendMessageToHub() :", "creating get hub instructions by id message");
                messageSerializerFunction = this._getHubInstructionsByIdSerializer;
                break;
            case this.UPLINK_PACKET_GET_UPLINK_IMITATORS_BY_ID:
                logger.log("Messaging.sendMessageToHub() :", "creating get uplink imitators by id message");
                messageSerializerFunction = this._getUplinkimitatorsByIdSerializer;
                break;
            default:
                logger.log("Messaging.sendMessageToHub", "packet type not handled");
        }

        return this.createGenericMessage(messageContextObject, messageSerializerFunction);
    }.bind(this);


    this.createGenericMessage = function(messageContextObject, messageSerializerFunction)
    {
        logger.log("Messaging.createGenericMessage() :", "creating generic message");

        var i = 0;
        var b64encodedMessage = '';
        //creating message object
        var messageObject = {header: null,body: null};

        messageObject.body = {
            bodyContent: messageContextObject.bodyContent
        };
        //adding message type to message body
        messageObject.body.messageType = messageContextObject.messageType;
        //adding header to message
        this._addHeaderToMessageObject(messageContextObject, messageObject);

        //serializing message object
        var serializedMessageArray = this._serializeMessage(messageObject, messageSerializerFunction);
        // //adding checksum to serialized message
        messageObject.body.checksum = this._addChecksumToSerializedMessageArray(serializedMessageArray);


        logger.log(messageObject, "message object");
        logger.log(serializedMessageArray , "raw message");
        console.log(serializedMessageArray , "raw message");
        var nonce = new Uint8Array(8);
        //extracting nonce from message
        for(i = 0; i < 8; i++){
            nonce[i] = serializedMessageArray[this._HEADER_NONCE_STARTING_BYTE + i];
        }

        var messageUint8Array = new Uint8Array(serializedMessageArray);
        //encrypting message
        this._encryptMessage(messageUint8Array, this._encryptionPSK, nonce);

        //nase64 encoding message
        b64encodedMessage = this._base64Encode(messageUint8Array);

        return {message: b64encodedMessage, messageType: messageObject.body.messageType, serializedMessageArray: serializedMessageArray};
    }.bind(this);


    this._takeOwnershipOfHubSerializer = function(serializedMessageArray, bodyContentObject)
    {
        logger.log("Messaging._takeOwnershipOfHubSerializer() :", "serializing take owner ship message object");

        this._serializeMessage_string(serializedMessageArray, bodyContentObject.password);
        this._serializeMessage_array(serializedMessageArray, bodyContentObject.psk);
    }.bind(this);


    this._setHubDateTimeSerializer = function(serializedMessageArray, bodyContentObject)
    {
        logger.log("Messaging._setHubDateTimeSerializer() :", "serializing set hub dateTime message object");

        this._serializeMessage_array(serializedMessageArray, this.utility.uint32ToLittleEndianUint8(bodyContentObject.dateStamp));
        this._serializeMessage_array(serializedMessageArray, this.utility.uint32ToLittleEndianUint8(bodyContentObject.timeStamp));
    }.bind(this);


    this._registerNewNodeSerializer = function(serializedMessageArray, bodyContentObject)
    {
        logger.log("Messaging._registerNewNodeSerializer() :", "serializing register new node message object");

        this._serializeMessage_array(serializedMessageArray, this.utility.uint32ToLittleEndianUint8(bodyContentObject.nodeUUID));
        this._serializeMessage_array(serializedMessageArray, bodyContentObject.nodeFallbackKey);
        this._serializeMessage_number(serializedMessageArray, bodyContentObject.deviceType);
        this._serializeMessage_number(serializedMessageArray, bodyContentObject.firmwareYear);
        this._serializeMessage_number(serializedMessageArray, bodyContentObject.firmwareMonth);
    }.bind(this);

    this._deleteNodeSerializer = function(serializedMessageArray, bodyContentObject)
    {
        logger.log("Messaging._deleteNodeSerializer() :", "serializing delete node message object");

        this._serializeMessage_array(serializedMessageArray, this.utility.uint32ToLittleEndianUint8(bodyContentObject.nodeUUID));

    }.bind(this);

    this._pairNodeSerializer = function(serializedMessageArray, bodyContentObject)
    {
        logger.log("Messaging._pairNodeSerializer() :", "serializing pair node message object");

        this._serializeMessage_array(serializedMessageArray, this.utility.uint32ToLittleEndianUint8(bodyContentObject.nodeUUID));

    }.bind(this);
    
    this._setParametersOfNodesSerializer = function(serializedMessageArray, bodyContentObject)
    {
        logger.log("Messaging._setParametersOfNodesSerializer() :", "serializing set parameters of nodes message object");

        this._serializeMessage_number(serializedMessageArray, bodyContentObject.nodeActions.length);
        for(var i = 0; i < bodyContentObject.nodeActions.length; i++){
            this._serializeMessage_array(serializedMessageArray, this.utility.uint32ToLittleEndianUint8(bodyContentObject.nodeActions[i].nodeUUID));
            this._serializeMessage_number(serializedMessageArray, bodyContentObject.nodeActions[i].actions.length);

            for(var j = 0; j < bodyContentObject.nodeActions[i].actions.length; j++){
                this._serializeMessage_array(serializedMessageArray, this.utility.uint16ToLittleEndianUint8(bodyContentObject.nodeActions[i].actions[j].parameterId));
                this._serializeMessage_parameter_value(serializedMessageArray, bodyContentObject.nodeActions[i].actions[j].parameterId, bodyContentObject.nodeActions[i].actions[j].valueOfChange);
                this._serializeMessage_number(serializedMessageArray, bodyContentObject.nodeActions[i].actions[j].typeOfAction);
                this._serializeMessage_array(serializedMessageArray, this.utility.uint16ToLittleEndianUint8(bodyContentObject.nodeActions[i].actions[j].timeDelay));
            }
        }

    }.bind(this);

    this.setParametersOfNodesSerializer = function(serializedMessageArray, bodyContentObject)
    {
        this._setParametersOfNodesSerializer(serializedMessageArray, bodyContentObject);
    }.bind(this);

    this._getNodesListSerializer = function()
    {
        logger.log("Messaging._getNodesListSerializer() :", "serializing get nodes list message object");

    }.bind(this);

    this._requestOtaSerializer = function()
    {
        logger.log("Messaging._requestOtaSerializer() :", "serializing request ota message object");

    }.bind(this);

    this._readNodeParametersSerializer = function(serializedMessageArray, bodyContentObject)
    {
        logger.log("Messaging._readNodeParametersSerializer() :", "serializing get node parameters message object");

        this._serializeMessage_array(serializedMessageArray, this.utility.uint32ToLittleEndianUint8(bodyContentObject.nodeUUID));

    }.bind(this);

    this._getWifiNetworksSerializer = function()
    {
        logger.log("Messaging._getWifiNetworksSerializer() :", "serializing get wifi networks message object");

    }.bind(this);

    this._setHubWifiSerializer = function(serializedMessageArray, bodyContentObject)
    {
        logger.log("Messaging._setHubWifiSerializer() :", "serializing set hub wifi message object");

        this._serializeMessage_number(serializedMessageArray, bodyContentObject.wifiMode);
        this._serializeMessage_array(serializedMessageArray, this.utility.stringToNullTerminatedArray(bodyContentObject.wifiPassword));
        this._serializeMessage_array(serializedMessageArray, this.utility.stringToNullTerminatedArray(bodyContentObject.wifiSSID));
        
    }.bind(this);
    
    this._readInstructionsSerializer = function(serializedMessageArray, bodyContentObject)
    {
        logger.log("Messaging._readInstructionsSerializer() :", "serializing read instructions message object");

        this._serializeMessage_array(serializedMessageArray, this.utility.uint32ToLittleEndianUint8(bodyContentObject.nodeUUID));

    }.bind(this);
    
    this._setInstructionsSerializer = function(serializedMessageArray, bodyContentObject)
    {
        logger.log("Messaging._setInstructionsSerializer() :", "serializing set instruction of hub message object");

        this._serializeMessage_array(serializedMessageArray, this.utility.uint32ToLittleEndianUint8(bodyContentObject.nodeUUID));
        this._serializeMessage_number(serializedMessageArray, bodyContentObject.instructionCount);
        for(var i = 0; i < bodyContentObject.instructionCount; i++){
            this._serializeMessage_array(serializedMessageArray, this.utility.uint16ToLittleEndianUint8(bodyContentObject.instructionList[i].eventToWatch.parameterId));
            this._serializeMessage_parameter_value(serializedMessageArray, bodyContentObject.instructionList[i].eventToWatch.parameterId, bodyContentObject.instructionList[i].eventToWatch.valueToReach);
            this._serializeMessage_number(serializedMessageArray, bodyContentObject.instructionList[i].eventToWatch.direction);
            this._serializeMessage_array(serializedMessageArray, this.utility.uint16ToLittleEndianUint8(bodyContentObject.instructionList[i].internalAction.parameterId));
            this._serializeMessage_parameter_value(serializedMessageArray, bodyContentObject.instructionList[i].internalAction.parameterId, bodyContentObject.instructionList[i].internalAction.valueOfChange);
            this._serializeMessage_number(serializedMessageArray, bodyContentObject.instructionList[i].internalAction.typeOfAction);
            this._serializeMessage_array(serializedMessageArray, this.utility.uint16ToLittleEndianUint8(bodyContentObject.instructionList[i].timeDelay));
        }

    }.bind(this);
    
    this._addNewUserSerializer = function(serializedMessageArray, bodyContentObject)
    {
        logger.log("Messaging._addNewUserSerializer() :", "serializing add new user message object");

        this._serializeMessage_array(serializedMessageArray, this.utility.uint32ToLittleEndianUint8(bodyContentObject.newUserUUID));
        this._serializeMessage_array(serializedMessageArray, this.utility.stringToNullTerminatedArray(bodyContentObject.password));

    }.bind(this);

    this._deleteUserSerializer = function(serializedMessageArray, bodyContentObject)
    {
        logger.log("Messaging._deleteUserSerializer() :", "serializing delete user message object");

        this._serializeMessage_array(serializedMessageArray, this.utility.uint32ToLittleEndianUint8(bodyContentObject.targetUserUUID));

    }.bind(this);

    this._changePasswordSerializer = function(serializedMessageArray, bodyContentObject)
    {
        logger.log("Messaging._changePasswordSerializer() :", "serializing change password message object");

        this._serializeMessage_array(serializedMessageArray, this.utility.stringToNullTerminatedArray(bodyContentObject.newPassword));

    }.bind(this);

    this._userLoginSerializer = function(serializedMessageArray, bodyContentObject)
    {
        logger.log("Messaging._userLoginSerializer() :", "serializing user login message object");

        this._serializeMessage_array(serializedMessageArray, bodyContentObject.psk);

    }.bind(this);

    this._readHubInstructionsSerializer = function()
    {
        logger.log("Messaging._readHubInstructionsSerializer() :", "serializing read hub instructions message object");

    }.bind(this);

    this._setHubInstructionSerializer = function(serializedMessageArray, bodyContentObject)
    {
        logger.log("Messaging._setHubInstructionSerializer() :", "serializing set hub instructions message object");

        this._serializeMessage_number(serializedMessageArray, bodyContentObject.instructionCount);
        for(var i = 0; i < bodyContentObject.instructionCount; i++){
            this._serializeMessage_array(serializedMessageArray, this.utility.uint16ToLittleEndianUint8(bodyContentObject.instructionList[i].eventIdToWatch));
            this._serializeMessage_number(serializedMessageArray, bodyContentObject.instructionList[i].commandLength);
            this._serializeMessage_array(serializedMessageArray, bodyContentObject.instructionList[i].commandToSend);
        }
    }.bind(this);
    
    this._readHubSchedulesSerializer = function()
    {
        logger.log("Messaging._readHubSchedulesSerializer() :", "serializing read hub schedules message object");

    }.bind(this);
    
    this._setHubScheduleSerializer = function(serializedMessageArray, bodyContentObject)
    {
        logger.log("Messaging._setHubScheduleSerializer() :", "serializing set schedule of hub message object");

        this._serializeMessage_number(serializedMessageArray, bodyContentObject.schedulesList.length);
        for(var i = 0; i < bodyContentObject.schedulesList.length; i++){
            this._serializeMessage_number(serializedMessageArray, bodyContentObject.schedulesList[i].timeEvent.repeatMask);
            this._serializeMessage_array(serializedMessageArray, this.utility.uint32ToLittleEndianUint8(bodyContentObject.schedulesList[i].timeEvent.dateStamp));
            this._serializeMessage_array(serializedMessageArray, this.utility.uint32ToLittleEndianUint8(bodyContentObject.schedulesList[i].timeEvent.timeStamp));
            this._serializeMessage_array(serializedMessageArray, this.utility.uint16ToLittleEndianUint8(bodyContentObject.schedulesList[i].eventId));
        }
    }.bind(this);
 
    this._readHubParametersSerializer = function()
    {
        logger.log("Messaging._readHubParametersSerializer() :", "serializing read hub parameters message object");

    }.bind(this);

    this._getUserListSerializer = function()
    {
        logger.log("Messaging._getUserListSerializer() :", "serializing get user list message object");

    }.bind(this);

    this._readParameterWatchesSerializer = function()
    {
        logger.log("Messaging._readParameterWatchesSerializer() :", "serializing read parameter watches object");

    }.bind(this);

    this._setParameterWatchesSerializer = function(serializedMessageArray, bodyContentObject)
    {
        logger.log("Messaging._setParameterWatchesSerializer() :", "serializing set parameter watches message object");

        this._serializeMessage_number(serializedMessageArray, bodyContentObject.watchList.length);
        for(var i = 0; i < bodyContentObject.watchList.length; i++){
            this._serializeMessage_array(serializedMessageArray, this.utility.uint32ToLittleEndianUint8(bodyContentObject.watchList[i].deviceUUID));
            this._serializeMessage_array(serializedMessageArray, this.utility.uint16ToLittleEndianUint8(bodyContentObject.watchList[i].parameterId));
            this._serializeMessage_array(serializedMessageArray, this.utility.uint32ToLittleEndianUint8(bodyContentObject.watchList[i].valueOfChange));
            this._serializeMessage_number(serializedMessageArray, bodyContentObject.watchList[i].relation);
            this._serializeMessage_array(serializedMessageArray, this.utility.uint16ToLittleEndianUint8(bodyContentObject.watchList[i].eventId));
        }
    }.bind(this);

    this._setEventMaskSerializer = function(serializedMessageArray, bodyContentObject)
    {
        logger.log("Messaging._setEventMaskSerializer() :", "serializing set event mask message object");

        this._serializeMessage_number(serializedMessageArray, bodyContentObject.maskList.length);
        for(var i = 0; i < bodyContentObject.maskList.length; i++){
            this._serializeMessage_array(serializedMessageArray, this.utility.uint16ToLittleEndianUint8(bodyContentObject.maskList[i].eventId));
            this._serializeMessage_number(serializedMessageArray, bodyContentObject.maskList[i].isMasked ? 1 : 0);
        }
    }.bind(this);

    this._getEventMasksSerializer = function()
    {
        logger.log("Messaging._getEventMasksSerializer() :", "serializing get event mask message object");

    }.bind(this);

    this._setUplinkImitatorsSerializer = function(serializedMessageArray, bodyContentObject)
    {
        logger.log("Messaging._setUplinkImitatorsSerializer() :", "serializing set uplink imitator message object");

        this._serializeMessage_number(serializedMessageArray, bodyContentObject.imitatorsList.length);
        for(var i = 0; i < bodyContentObject.imitatorsList.length; i++){
            this._serializeMessage_array(serializedMessageArray, this.utility.uint16ToLittleEndianUint8(bodyContentObject.imitatorsList[i].eventIdToWatch));
            this._serializeMessage_array(serializedMessageArray, this.utility.uint16ToLittleEndianUint8(bodyContentObject.imitatorsList[i].commandLength));
            this._serializeMessage_array(serializedMessageArray, bodyContentObject.imitatorsList[i].commandToSend);
        }
    }.bind(this);

    this._getUplinkImitatorsSerializer = function()
    {
        logger.log("Messaging._getUplinkImitatorsSerializer() :", "serializing get uplink imitator message object");

    }.bind(this);

    this._modifyParameterWatchesSerializer = function(serializedMessageArray, bodyContentObject)
    {
        logger.log("Messaging._modifyParameterWatchesSerializer() :", "serializing modify parameter watches message object");

        this._serializeMessage_number(serializedMessageArray, bodyContentObject.watchList.length);
        for(var i = 0; i < bodyContentObject.watchList.length; i++){
            this._serializeMessage_array(serializedMessageArray, this.utility.uint32ToLittleEndianUint8(bodyContentObject.watchList[i].deviceUUID));
            this._serializeMessage_array(serializedMessageArray, this.utility.uint16ToLittleEndianUint8(bodyContentObject.watchList[i].parameterId));
            this._serializeMessage_array(serializedMessageArray, this.utility.uint32ToLittleEndianUint8(bodyContentObject.watchList[i].valueOfChange));
            this._serializeMessage_number(serializedMessageArray, bodyContentObject.watchList[i].relation);
            this._serializeMessage_array(serializedMessageArray, this.utility.uint16ToLittleEndianUint8(bodyContentObject.watchList[i].eventId));
        }
    }.bind(this);

    this._modifyHubInstructionsSerializer = function(serializedMessageArray, bodyContentObject)
    {
        logger.log("Messaging._modifyHubInstructionsSerializer() :", "serializing modify hub instructions message object");

        this._serializeMessage_number(serializedMessageArray, bodyContentObject.instructionCount);
        for(var i = 0; i < bodyContentObject.instructionCount; i++){
            this._serializeMessage_array(serializedMessageArray, this.utility.uint16ToLittleEndianUint8(bodyContentObject.instructionList[i].eventIdToWatch));
            this._serializeMessage_number(serializedMessageArray, bodyContentObject.instructionList[i].commandLength);
            this._serializeMessage_array(serializedMessageArray, bodyContentObject.instructionList[i].commandToSend);
        }
    }.bind(this);

    this._deleteHubInstructionsSerializer = function(serializedMessageArray, bodyContentObject)
    {
        logger.log("Messaging._deleteHubInstructionsSerializer() :", "serializing delete hub instructions message object");

        this._serializeMessage_number(serializedMessageArray, bodyContentObject.instructionsList.length);
        for(var i = 0; i < bodyContentObject.instructionsList.length; i++){
            this._serializeMessage_array(serializedMessageArray, this.utility.uint16ToLittleEndianUint8(bodyContentObject.instructionsList[i].eventIdToWatch));
        }
    }.bind(this);

    this._setEventNotificationsSerializer = function(serializedMessageArray, bodyContentObject)
    {
        logger.log("Messaging._setEventNotificationsSerializer() :", "serializing set event notifications message object");

        this._serializeMessage_number(serializedMessageArray, bodyContentObject.notificationsList.length);
        for(var i = 0; i < bodyContentObject.notificationsList.length; i++){
            this._serializeMessage_array(serializedMessageArray, this.utility.uint16ToLittleEndianUint8(bodyContentObject.notificationsList[i].eventId));
            this._serializeMessage_number(serializedMessageArray, bodyContentObject.notificationsList[i].isNotified ? 1 : 0);
        }
    }.bind(this);

    this._readEventNotificationsSerializer = function()
    {
        logger.log("Messaging._readEventNotificationsSerializer() :", "serializing read event notifications message object");

    }.bind(this);



    this._addHeaderToMessageObject = function(messageContextObject, messageObject)
    {
        logger.log("Messaging._addHeaderToMessageObject() :", "adding header to message object");

        var currentDateTimeStamp = this.getDateTimeStamp();
        messageObject.header = {
            protocolVersion: this._protocolVersion,
            source: this._messageSource,
            destination: this._messageDestination,
            nonce: {
                dateStamp: currentDateTimeStamp.date,
                timeStamp: currentDateTimeStamp.time
            }
        }
    }.bind(this);


    this.processReceivedMessage = function(hubObject)
    {
        return new Promise(function (resolve, reject) {
            logger.log("Messaging.processReceivedMessage() :", "processing received message");

            var encryptedMessageArray = this._base64Decode(hubObject.response);

            if(encryptedMessageArray.length >= this._headerLength + 3){
                var messageHeaderObject = this._extractHeaderFromMessage(encryptedMessageArray);

                if(messageHeaderObject.header.destination == this._messageSource && messageHeaderObject.header.source == this._messageDestination){
                    logger.log("Messaging.processReceivedMessage() :", "destination and source of message match ours so let's decrypt it");
                    var nonce = new Uint8Array(8);
                    //extracting nonce from encryptedMessageArray
                    for(var i = 0; i < 8; i++){
                        nonce[i] = encryptedMessageArray[this._HEADER_NONCE_STARTING_BYTE + i];
                    }
            
                    var messageUint8Array = new Uint8Array(encryptedMessageArray);
                    //encrypting message
                    this._encryptMessage(messageUint8Array, this._encryptionPSK, nonce);

                    var checksum = this.utility.littleEndianUint8ToUint16( [messageUint8Array[this._BODY_CHECKSUM_STARTING_BYTE], messageUint8Array[this._BODY_CHECKSUM_STARTING_BYTE + 1]] );
                    if(this._validateChecksum(messageUint8Array, checksum)){
                        var receivedMessageObject = this._extractBodyFromMessage(messageHeaderObject, messageUint8Array, hubObject.dueResponsePacketType);
                        logger.log("Messaging.processReceivedMessage", "extracting received message: ");
                        logger.log(receivedMessageObject, "received message object");
                        if(!receivedMessageObject.body.bodyContent.packetIntegrity){
                            // console.error(receivedMessageObject);
                            console.error('Luxin: packet integrity failed');
                            reject();
                        }
                        console.log('receivedMessageObject' ,   receivedMessageObject)
                        switch(receivedMessageObject.body.messageType){
                            case this.UPLINK_PACKET_FAILURE:
                                logger.log("Messaging.processReceivedMessage() :", "received messageType: UPLINK_PACKET_FAILURE");
                                reject();
                                break;
                            case this.UPLINK_PACKET_TIME_NOT_SET:
                                logger.log("Messaging.processReceivedMessage() :", "received messageType: UPLINK_PACKET_TIME_NOT_SET");
                                reject();
                                break;
                            case this.UPLINK_PACKET_NOT_PRIVILEGED:
                                logger.log("Messaging.processReceivedMessage() :", "received messageType: UPLINK_PACKET_NOT_PRIVILEGED");
                                reject();
                                break;
                            case this.UPLINK_PACKET_SUCCESS:
                                logger.log("Messaging.processReceivedMessage() :", "received messageType: UPLINK_PACKET_SUCCESS");
                                resolve(receivedMessageObject);
                                break;
                            default:
                                logger.log("Messaging.processReceivedMessage() :", "received messageType: not handled: " + receivedMessageObject.body.messageType);
                                reject();
                        }
                    }else{
                        logger.log('checksum error');
                        reject();
                    }
                }else{
                    logger.log("Messaging.processReceivedMessage() :", "message destination is not this user or hub is not ours");
                    reject();
                }
            }else{
                console.log('message too short');
                reject();
            }
        }.bind(this))
    }.bind(this);


    this._validateChecksum = function(messageUint8Array, checksum)
    {
        var calculatedChecksum = 0;
        for(var i = this._BODY_CHECKSUM_CALCULATION_STARTING_BYTE; i < messageUint8Array.length; i++){
            calculatedChecksum += messageUint8Array[i];
        }
        calculatedChecksum = calculatedChecksum & 0xFFFF;

        logger.log("Messaging._validateChecksum() :", "validating checksum: " + (calculatedChecksum == checksum));
        return calculatedChecksum == checksum;

    }.bind(this);


    this._extractHeaderFromMessage = function(encryptedMessageArray)
    {
        logger.log("Messaging._extractHeaderFromMessage() :", "extracting header");

        var protocolVersion = encryptedMessageArray[this._HEADER_PROTOCOL_VERSION_STARTING_BYTE];
        var sourceArray = [
            encryptedMessageArray[this._HEADER_SOURCE_UUID_STARTING_BYTE],
            encryptedMessageArray[this._HEADER_SOURCE_UUID_STARTING_BYTE + 1],
            encryptedMessageArray[this._HEADER_SOURCE_UUID_STARTING_BYTE + 2],
            encryptedMessageArray[this._HEADER_SOURCE_UUID_STARTING_BYTE + 3]
        ];
        var source = this.utility.littleEndianUint8ToUint32(sourceArray);
        var destinationArray = [
            encryptedMessageArray[this._HEADER_DESTINATION_UUID_STARTING_BYTE],
            encryptedMessageArray[this._HEADER_DESTINATION_UUID_STARTING_BYTE + 1],
            encryptedMessageArray[this._HEADER_DESTINATION_UUID_STARTING_BYTE + 2],
            encryptedMessageArray[this._HEADER_DESTINATION_UUID_STARTING_BYTE + 3]
        ];
        var destination = this.utility.littleEndianUint8ToUint32(destinationArray);
        var dateStampArray = [
            encryptedMessageArray[this._HEADER_DATESTAMP_STARTING_BYTE],
            encryptedMessageArray[this._HEADER_DATESTAMP_STARTING_BYTE + 1],
            encryptedMessageArray[this._HEADER_DATESTAMP_STARTING_BYTE + 2],
            encryptedMessageArray[this._HEADER_DATESTAMP_STARTING_BYTE + 3]
        ];
        var dateStamp = this.utility.littleEndianUint8ToUint32(dateStampArray);
        var timeStampArray = [
            encryptedMessageArray[this._HEADER_TIMESTAMP_STARTING_BYTE],
            encryptedMessageArray[this._HEADER_TIMESTAMP_STARTING_BYTE + 1],
            encryptedMessageArray[this._HEADER_TIMESTAMP_STARTING_BYTE + 2],
            encryptedMessageArray[this._HEADER_TIMESTAMP_STARTING_BYTE + 3]
        ];
        var timeStamp = this.utility.littleEndianUint8ToUint32(timeStampArray);

        var messageHeaderObject = {
            body: null,
            header: {
                protocolVersion: protocolVersion,
                source: source,
                destination: destination,
                nonce: {
                    dateStamp: dateStamp,
                    timeStamp: timeStamp
                }
            }
        }

        return messageHeaderObject;
    }.bind(this);

    this._extractBodyFromMessage = function(messageObject, decryptedMessageArray, dueResponsePacketType)
    {
        logger.log("Messaging._extractBodyFromMessage() :", "extracting body");

        var checksumLittleEndianArray = [decryptedMessageArray[this._BODY_CHECKSUM_STARTING_BYTE], decryptedMessageArray[this._BODY_CHECKSUM_STARTING_BYTE + 1]];
        var checksum = this.utility.littleEndianUint8ToUint16( checksumLittleEndianArray );
        var messageType = decryptedMessageArray[this._BODY_PACKET_TYPE_STARTING_BYTE];

        messageObject.body = {
            checksum: checksum,
            messageType: messageType,
            bodyContent: {}
        }
        messageObject.body.bodyContent.packetIntegrity = true;
        if(messageType == this.UPLINK_PACKET_SUCCESS){
            switch(dueResponsePacketType){
                case this.UPLINK_PACKET_USER_LOGIN:
                    this._userLoginDeserializer(messageObject.body.bodyContent, decryptedMessageArray);
                    break;
                case this.UPLINK_PACKET_TAKE_OWNERSHIP:
                    //no body content
                    break;
                case this.UPLINK_PACKET_SET_HUB_TIME:
                    //no body content
                    break;
                case this.UPLINK_PACKET_SEND_COMMAND:
                    //no body content
                    break;
                case this.UPLINK_PACKET_HEY_LUXIN:
                    break;
                case this.UPLINK_PACKET_NEW_USER:
                    //no body content
                    break;
                case this.UPLINK_PACKET_REMOVE_USER:
                    //no body content
                    break;
                case this.UPLINK_PACKET_WIFI_SCAN:
                    this._scanWifiNetworksDeserializer(messageObject.body.bodyContent, decryptedMessageArray);
                    break;
                case this.UPLINK_PACKET_WIFI_CONFIG:
                    //no body content
                    break;
                case this.UPLINK_PACKET_REGISTER_NODE:
                    //no body content
                    break;
                case this.UPLINK_PACKET_PAIR_NODE:
                    //no body content
                    break;
                case this.UPLINK_PACKET_REMOVE_NODE:
                    //no body content
                    break;
                case this.UPLINK_PACKET_OTA_UPDATE_COMMAND:
                    //no body content
                    break;
                case this.UPLINK_PACKET_GET_WARNINGS_REQUEST:
                    break;
                case this.UPLINK_PACKET_UPDATE_PSK_REQUES:
                    break;
                case this.UPLINK_PACKET_SET_NODE_INSTRUCTIONS:
                    //no body content
                    break;
                case this.UPLINK_PACKET_SET_HUB_INSTRUCTIONS:
                    //no body content
                    break;
                case this.UPLINK_PACKET_READ_NODE_INSTRUCTIONS:
                    this._readNodeInstructionsDeserializer(messageObject.body.bodyContent, decryptedMessageArray);
                    break;
                case this.UPLINK_PACKET_READ_NODE_PARAMETERS:
                    this._getNodeParametersDeserializer(messageObject.body.bodyContent, decryptedMessageArray);
                    break;
                case this.UPLINK_PACKET_READ_HUB_INSTRUCTIONS:
                        this._readHubInstructionsDeserializer(messageObject.body.bodyContent, decryptedMessageArray);
                    break;
                case this.UPLINK_PACKET_READ_HUB_SCHEDULES:
                        this._readHubSchedulesDeserializer(messageObject.body.bodyContent, decryptedMessageArray);
                    break;
                case this.UPLINK_PACKET_READ_HUB_PARAMETERS:
                        this._readHubParametersDeserializer(messageObject.body.bodyContent, decryptedMessageArray);
                    break;
                case this.UPLINK_PACKET_GET_NODES_LIST:
                    this._getNodesListDeserializer(messageObject.body.bodyContent, decryptedMessageArray);
                    break;
                case this.UPLINK_PACKET_SET_HUB_SCHEDULES:
                    //no body content
                    break;
                case this.UPLINK_PACKET_CHANGE_PASSWORD:
                    //no body content
                    break;
                case this.UPLINK_PACKET_GET_USERS_LIST:
                    this._getUserListDeserializer(messageObject.body.bodyContent, decryptedMessageArray);
                    break;
                case this.UPLINK_PACKET_SET_PARAMETER_WATCHES:
                    //no body content
                    break;
                case this.UPLINK_PACKET_READ_PARAMETER_WATCHES:
                    this._getParameterWatchesDeserializer(messageObject.body.bodyContent, decryptedMessageArray);
                    break;
                case this.UPLINK_PACKET_SET_EVENT_MASKS:
                    //no body content
                    break;
                case this.UPLINK_PACKET_GET_EVENT_MASKS:
                    this._getEventMasksDeserializer(messageObject.body.bodyContent, decryptedMessageArray);
                    break;
                case this.UPLINK_PACKET_SET_UPLINK_IMITATORS:
                    //no body content
                    break;
                case this.UPLINK_PACKET_GET_UPLINK_IMITATORS:
                    this._getUplinkImitatorsDeserializer(messageObject.body.bodyContent, decryptedMessageArray);
                    break;
                case this.UPLINK_PACKET_MODIFY_PARAMETER_WATCHES:
                    //no body content
                    break;
                case this.UPLINK_PACKET_MODIFY_HUB_INSTRUCTIONS:
                    //no body content
                    break;
                case this.UPLINK_PACKET_DELETE_HUB_INSTRUCTIONS_BY_EVENT_ID:
                    //no body content
                    break;
                case this.UPLINK_PACKET_SET_EVENT_NOTIFICATIONS:
                    //no body content
                    break;
                case this.UPLINK_PACKET_READ_EVENT_NOTIFICATIONS:
                    this._readEventNotificationsDeserializer(messageObject.body.bodyContent, decryptedMessageArray);
                    break;
                default:
                    logger.log("Messaging._extractBodyFromMessage()", "case default, dueResponsePacketType: " + dueResponsePacketType);
            }
        }

        return messageObject;
    }.bind(this);


    this._getNodesListDeserializer = function(bodyContentObject, decryptedMessageArray)
    {
        logger.log("Messaging._getNodesListDeserializer() :", "deserializing received packet");

        var arrayIterator = this._headerLength + 3;
        bodyContentObject.nodeCount = decryptedMessageArray[arrayIterator++];
        bodyContentObject.nodeStats = [];
        for(var i = 0; i < bodyContentObject.nodeCount; i++){
            var nodeStatObject = {
                uuid: null,
                deviceType: null,
                firmwareYear: null,
                firmwareMonth: null,
                isOnline: null,
                parameterCount: null,
                parameterList: []
            };
            nodeStatObject.uuid = this.utility.littleEndianUint8ToUint32([decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++]]) >>> 0;
            nodeStatObject.deviceType = decryptedMessageArray[arrayIterator++];
            nodeStatObject.firmwareYear = decryptedMessageArray[arrayIterator++];
            nodeStatObject.firmwareMonth = decryptedMessageArray[arrayIterator++];
            nodeStatObject.isOnline = decryptedMessageArray[arrayIterator++];
            nodeStatObject.parameterCount = decryptedMessageArray[arrayIterator++];
            for(var j = 0; j < nodeStatObject.parameterCount; j++){
                var parameterObject = {
                    id: 0,
                    value: null,
                }
                parameterObject.id = this.utility.littleEndianUint8ToUint16([decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++]]);
                parameterObject.parameterLength = this.utility.resolveParameterLength(parameterObject.id);
                switch(parameterObject.parameterLength){
                    case 1:
                        parameterObject.value = decryptedMessageArray[arrayIterator++];
                        break;
                    case 2:
                        parameterObject.value = this.utility.littleEndianUint8ToUint16( [decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++]]);
                        break;
                    case 4:
                        parameterObject.value = this.utility.littleEndianUint8ToUint32( [decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++]]);
                        break;
                    case 32:
                        parameterObject.value = [];
                        for(var k = 0; k < 32; k++){
                            parameterObject.value.push( decryptedMessageArray[arrayIterator++] );
                        }
                        break;
                    default:
                        logger.log("Messaging._getNodesListDeserializer()", "case default, parameter length: " + parameterObject.parameterLength);
                }
                nodeStatObject.parameterList.push(parameterObject);
            }
            bodyContentObject.nodeStats.push(nodeStatObject);
        }
        if(arrayIterator != decryptedMessageArray.length){
            // console.log('here');
            bodyContentObject.packetIntegrity = false;
        }
    }.bind(this);

    this._getNodeParametersDeserializer = function(bodyContentObject, decryptedMessageArray)
    {
        logger.log("Messaging._getNodeParametersDeserializer() :", "deserializing received packet");

        var arrayIterator = this._headerLength + 3;
        bodyContentObject.parameterCount = decryptedMessageArray[arrayIterator++];
        bodyContentObject.parameterList = [];
        for(var i = 0; i < bodyContentObject.parameterCount; i++){
            var parameterObject = {};
            parameterObject.id = this.utility.littleEndianUint8ToUint16([decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++]]);
            parameterObject.parameterLength = this.utility.resolveParameterLength(parameterObject.id);
            //todo: add other cases
            switch(parameterObject.parameterLength){
                case 1:
                    parameterObject.value = decryptedMessageArray[arrayIterator++];
                    break;
                case 2:
                    parameterObject.value = this.utility.littleEndianUint8ToUint16( [decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++]]);
                    break;
                case 4:
                    parameterObject.value = this.utility.littleEndianUint8ToUint32( [decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++]]);
                    break;
                case 32:
                    parameterObject.value = [];
                    for(var j = 0; j < 32; j++){
                        parameterObject.value.push( decryptedMessageArray[arrayIterator++] );
                    }
                    break;
                default:
                    logger.log("Messaging._getNodeParametersDeserializer()", "case default, parameter length: " + parameterObject.parameterLength);
            }
            bodyContentObject.parameterList.push( parameterObject );
        }
        if(arrayIterator != decryptedMessageArray.length){
            // console.log('here');
            bodyContentObject.packetIntegrity = false;
        }
    }.bind(this);
    this._scanWifiNetworksDeserializer = function(bodyContentObject, decryptedMessageArray)
    {
        logger.log("Messaging._scanWifiNetworksDeserializer() :", "deserializing received packet");

        var arrayIterator = this._headerLength + 3;
        bodyContentObject.networksCount = decryptedMessageArray[arrayIterator++];
        bodyContentObject.networkList = [];
        for(var i = 0; i < bodyContentObject.networksCount; i++){
            var networkObject = {};
            networkObject.ssid = '';
            while(decryptedMessageArray[arrayIterator]){
                networkObject.ssid += String.fromCharCode(decryptedMessageArray[arrayIterator++]);
            }
            arrayIterator++;
            networkObject.encryption = decryptedMessageArray[arrayIterator++];
            networkObject.rssi = decryptedMessageArray[arrayIterator++];
            bodyContentObject.networkList.push( networkObject );
        }
        if(arrayIterator != decryptedMessageArray.length){
            // console.log('here');
            bodyContentObject.packetIntegrity = false;
        }
    }.bind(this);

    this._readNodeInstructionsDeserializer = function(bodyContentObject, decryptedMessageArray)
    {
        logger.log("Messaging._readNodeInstructionsDeserializer() :", "deserializing received packet");

        var arrayIterator = this._headerLength + 3;
        bodyContentObject.instructionCount = decryptedMessageArray[arrayIterator++];
        bodyContentObject.instructionList = [];
        for(var i = 0; i < bodyContentObject.instructionCount; i++){
            var instructionObject = {eventToWatch: {}, internalAction: {}, timeDelay: 0};
            instructionObject.eventToWatch.parameterId = this.utility.littleEndianUint8ToUint16([decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++]]);
            instructionObject.eventToWatch.parameterLength = this.utility.resolveParameterLength(instructionObject.eventToWatch.parameterId);
            //todo: add other cases
            switch(instructionObject.eventToWatch.parameterLength){
                case 1:
                    instructionObject.eventToWatch.valueToReach = decryptedMessageArray[arrayIterator++];
                    break;
                case 2:
                    instructionObject.eventToWatch.valueToReach = this.utility.littleEndianUint8ToUint16( [decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++]]);
                    break;
                case 4:
                    instructionObject.eventToWatch.valueToReach = this.utility.littleEndianUint8ToUint32( [decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++]]);
                    break;
                case 32:
                    instructionObject.eventToWatch.valueToReach = [];
                    for(var j = 0; j < 32; j++){
                        instructionObject.eventToWatch.valueToReach.push( decryptedMessageArray[arrayIterator++] );
                    }
                    break;
                default:
                    logger.log("Messaging._readNodeInstructionsDeserializer()", "case default, parameter length: " + instructionObject.eventToWatch.parameterLength);
            }
            instructionObject.eventToWatch.direction = decryptedMessageArray[arrayIterator++];
            instructionObject.internalAction.parameterId = this.utility.littleEndianUint8ToUint16([decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++]]);
            instructionObject.internalAction.parameterLength = this.utility.resolveParameterLength(instructionObject.internalAction.parameterId);
            //todo: add other cases
            switch(instructionObject.internalAction.parameterLength){
                case 1:
                    instructionObject.internalAction.valueOfChange = decryptedMessageArray[arrayIterator++];
                    break;
                case 2:
                    instructionObject.internalAction.valueOfChange = this.utility.littleEndianUint8ToUint16( [decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++]]);
                    break;
                case 4:
                    instructionObject.internalAction.valueOfChange = this.utility.littleEndianUint8ToUint32( [decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++]]);
                    break;
                case 32:
                    instructionObject.internalAction.valueOfChange = [];
                    for(j = 0; j < 32; j++){
                        instructionObject.internalAction.valueOfChange.push( decryptedMessageArray[arrayIterator++] );
                    }
                    break;
                default:
                    logger.log("Messaging._readNodeInstructionsDeserializer()", "case default, parameter length: " + instructionObject.internalAction.parameterLength);
            }
            instructionObject.internalAction.typeOfAction = decryptedMessageArray[arrayIterator++];
            instructionObject.timeDelay = this.utility.littleEndianUint8ToUint16([decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++]]);
            bodyContentObject.instructionList.push( instructionObject );
        }
        if(arrayIterator != decryptedMessageArray.length){
            // console.log('here');
            bodyContentObject.packetIntegrity = false;
        }
    }.bind(this);
    this._readHubInstructionsDeserializer = function(bodyContentObject, decryptedMessageArray)
    {
        logger.log("Messaging._readHubInstructionsDeserializer() :", "deserializing received packet");

        var arrayIterator = this._headerLength + 3;
        bodyContentObject.instructionCount = decryptedMessageArray[arrayIterator++];
        bodyContentObject.instructionList = [];
        for(var i = 0; i < bodyContentObject.instructionCount; i++){
            var instructionObject = {eventIdToWatch: 0, commandLength: 0, commandToSend: [], nodeActions: []};
            instructionObject.eventIdToWatch = this.utility.littleEndianUint8ToUint16([decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++]]);
            instructionObject.commandLength = decryptedMessageArray[arrayIterator++];

            for(var j = 0; j < instructionObject.commandLength; j++){
                instructionObject.commandToSend.push(decryptedMessageArray[arrayIterator++]);
            }
            var commandIterator = 0;
            var nodeCount = instructionObject.commandToSend[commandIterator++];
            for(j = 0; j < nodeCount; j++){
                var nodeUUID = this.utility.littleEndianUint8ToUint32([instructionObject.commandToSend[commandIterator++], instructionObject.commandToSend[commandIterator++], instructionObject.commandToSend[commandIterator++], instructionObject.commandToSend[commandIterator++]]);
                var actionCount = instructionObject.commandToSend[commandIterator++];
                var actions = [];
                for(var k = 0; k < actionCount; k++){
                    var parameterId = this.utility.littleEndianUint8ToUint16([instructionObject.commandToSend[commandIterator++], instructionObject.commandToSend[commandIterator++]]);
                    var parameterLength = this.utility.resolveParameterLength(parameterId);
                    var valueOfChange = 0;
                    switch(parameterLength){
                        case 1:
                            valueOfChange = instructionObject.commandToSend[commandIterator++];
                            break;
                        case 2:
                            valueOfChange = this.utility.littleEndianUint8ToUint16( [instructionObject.commandToSend[commandIterator++], instructionObject.commandToSend[commandIterator++]]);
                            break;
                        case 4:
                            valueOfChange = this.utility.littleEndianUint8ToUint32( [instructionObject.commandToSend[commandIterator++], instructionObject.commandToSend[commandIterator++], instructionObject.commandToSend[commandIterator++], instructionObject.commandToSend[commandIterator++]]);
                            break;
                        case 32:
                            valueOfChange = [];
                            for(var l = 0; l < 32; l++){
                                valueOfChange.push( instructionObject.commandToSend[commandIterator++] );
                            }
                            break;
                        case 64:
                            valueOfChange = [];
                            for(l = 0; l < 64; l++){
                                valueOfChange.push( instructionObject.commandToSend[commandIterator++] );
                            }
                            break;
                        case 128:
                            valueOfChange = [];
                            for(l = 0; l < 128; l++){
                                valueOfChange.push( instructionObject.commandToSend[commandIterator++] );
                            }
                            break;
                        default:
                            logger.log("Messaging._readHubInstructionsDeserializer()", "case default, parameter length: " + parameterLength);
                    }
                    var typeOfAction = instructionObject.commandToSend[commandIterator++];
                    var timeDelay = this.utility.littleEndianUint8ToUint16( [instructionObject.commandToSend[commandIterator++], instructionObject.commandToSend[commandIterator++]]);
                    actions.push({
                        parameterId: parameterId,
                        valueOfChange: valueOfChange,
                        typeOfAction: typeOfAction,
                        timeDelay: timeDelay,
                    });
                }
                instructionObject.nodeActions.push({
                    nodeUUID: nodeUUID,
                    actions: actions,
                })
            }
            bodyContentObject.instructionList.push( instructionObject );
        }
        if(arrayIterator != decryptedMessageArray.length){
            // console.log('here');
            bodyContentObject.packetIntegrity = false;
        }
    }.bind(this);
    this.commandDeserializer = function (command) {
        var nodeActions = [];
        var commandIterator = 0;
        var nodeCount = command[commandIterator++];
        for(var i = 0; i < nodeCount; i++){
            var nodeUUID = this.utility.littleEndianUint8ToUint32([command[commandIterator++], command[commandIterator++], command[commandIterator++], command[commandIterator++]]);
            var actionCount = command[commandIterator++];
            var actions = [];
            for(var j = 0; j < actionCount; j++){
                var parameterId = this.utility.littleEndianUint8ToUint16([command[commandIterator++], command[commandIterator++]]);
                var parameterLength = this.utility.resolveParameterLength(parameterId);
                var valueOfChange = 0;
                switch(parameterLength){
                    case 1:
                        valueOfChange = command[commandIterator++];
                        break;
                    case 2:
                        valueOfChange = this.utility.littleEndianUint8ToUint16( [command[commandIterator++], command[commandIterator++]]);
                        break;
                    case 4:
                        valueOfChange = this.utility.littleEndianUint8ToUint32( [command[commandIterator++], command[commandIterator++], command[commandIterator++], command[commandIterator++]]);
                        break;
                    case 32:
                        valueOfChange = [];
                        for(var l = 0; l < 32; l++){
                            valueOfChange.push( command[commandIterator++] );
                        }
                        break;
                    case 64:
                        valueOfChange = [];
                        for(l = 0; l < 64; l++){
                            valueOfChange.push( command[commandIterator++] );
                        }
                        break;
                    case 128:
                        valueOfChange = [];
                        for(l = 0; l < 128; l++){
                            valueOfChange.push( command[commandIterator++] );
                        }
                        break;
                    default:
                        logger.log("Messaging.commandDeserializer()", "case default, parameter length: " + parameterLength);
                }
                var typeOfAction = command[commandIterator++];
                var timeDelay = this.utility.littleEndianUint8ToUint16( [command[commandIterator++], command[commandIterator++]]);
                actions.push({
                    parameterId: parameterId,
                    valueOfChange: valueOfChange,
                    typeOfAction: typeOfAction,
                    timeDelay: timeDelay,
                });
            }
            nodeActions.push({
                nodeUUID: nodeUUID,
                actions: actions,
            })
        }
        return nodeActions;
    }
    this.setEventMasksDeserializer = function(command)
    {
        logger.log("Messaging.setEventMasksDeserializer() :", "deserializing set event masks packet");

        var bodyContentObject = {};
        var arrayIterator = 1;
        bodyContentObject.maskCount = command[arrayIterator++];
        bodyContentObject.maskList = [];
        for(var i = 0; i < bodyContentObject.maskCount; i++){
            var eventId = this.utility.littleEndianUint8ToUint16([command[arrayIterator++], command[arrayIterator++]]);
            bodyContentObject.maskList.push(
                {
                    eventId: eventId,
                    isMasked: command[arrayIterator++] == 1,
                }
            );
        }
        return bodyContentObject;
    }.bind(this);
    this._readHubSchedulesDeserializer = function(bodyContentObject, decryptedMessageArray)
    {
        logger.log("Messaging._readHubSchedulesDeserializer() :", "deserializing received packet");

        var arrayIterator = this._headerLength + 3;
        bodyContentObject.schedulesCount = decryptedMessageArray[arrayIterator++];
        bodyContentObject.schedulesList = [];
        for(var i = 0; i < bodyContentObject.schedulesCount; i++){
            var scheduleObject = {timeEvent: {repeatMask: 0, dateStamp: 0, timeStamp: 0}, eventId: 0};
            scheduleObject.timeEvent.repeatMask = decryptedMessageArray[arrayIterator++];
            scheduleObject.timeEvent.dateStamp = this.utility.littleEndianUint8ToUint32([decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++]]);
            scheduleObject.timeEvent.timeStamp = this.utility.littleEndianUint8ToUint32([decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++]]);
            scheduleObject.eventId = this.utility.littleEndianUint8ToUint16([decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++]]);

            bodyContentObject.schedulesList.push( scheduleObject );
        }
        if(arrayIterator != decryptedMessageArray.length){
            // console.log('here');
            bodyContentObject.packetIntegrity = false;
        }
    }.bind(this);
    this._readHubParametersDeserializer = function(bodyContentObject, decryptedMessageArray)
    {
        logger.log("Messaging._readHubParametersDeserializer() :", "deserializing received packet");

        var arrayIterator = this._headerLength + 3;
        bodyContentObject.hubUUID = this.utility.littleEndianUint8ToUint32([decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++]]);
        bodyContentObject.firmwareYear = decryptedMessageArray[arrayIterator++];
        bodyContentObject.firmwareMonth = decryptedMessageArray[arrayIterator++];
        bodyContentObject.hubIP = [];
        bodyContentObject.hubIP.push(decryptedMessageArray[arrayIterator++]);
        bodyContentObject.hubIP.push(decryptedMessageArray[arrayIterator++]);
        bodyContentObject.hubIP.push(decryptedMessageArray[arrayIterator++]);
        bodyContentObject.hubIP.push(decryptedMessageArray[arrayIterator++]);
        bodyContentObject.isMQTTConnected = decryptedMessageArray[arrayIterator++];
        bodyContentObject.wifiType = decryptedMessageArray[arrayIterator++];
        bodyContentObject.ssid = '';
        for(var i = 0; i < 32; i++){
            var ssidChar = decryptedMessageArray[arrayIterator++];
            if(ssidChar != 0 && ssidChar != undefined){
                bodyContentObject.ssid += String.fromCharCode(ssidChar);
            }else{
                arrayIterator--;
                break;
            }
        }
        if(arrayIterator != decryptedMessageArray.length){
            // console.log('here');
            bodyContentObject.packetIntegrity = false;
        }
    }.bind(this);
    this._getUserListDeserializer = function(bodyContentObject, decryptedMessageArray)
    {
        logger.log("Messaging._getUserListDeserializer() :", "deserializing get user list packet");

        var arrayIterator = this._headerLength + 3;
        bodyContentObject.userCount = decryptedMessageArray[arrayIterator++];
        bodyContentObject.userList = [];
        for(var i = 0; i < bodyContentObject.userCount; i++){
            bodyContentObject.userList.push({
                uuid: this.utility.littleEndianUint8ToUint32([decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++]])
            });
        }
        if(arrayIterator != decryptedMessageArray.length){
            // console.log('here');
            bodyContentObject.packetIntegrity = false;
        }
    }.bind(this);
    this._userLoginDeserializer = function(bodyContentObject, decryptedMessageArray)
    {
        logger.log("Messaging._userLoginDeserializer() :", "deserializing user login packet");

        var arrayIterator = this._headerLength + 3;
        bodyContentObject.isOwner = decryptedMessageArray[arrayIterator++];
        if(arrayIterator != decryptedMessageArray.length){
            // console.log('here');
            bodyContentObject.packetIntegrity = false;
        }
    }.bind(this);
    this._getParameterWatchesDeserializer = function(bodyContentObject, decryptedMessageArray)
    {
        logger.log("Messaging._getParameterWatchesDeserializer() :", "deserializing get parameter watches packet");

        var arrayIterator = this._headerLength + 3;
        bodyContentObject.watchCount = decryptedMessageArray[arrayIterator++];
        bodyContentObject.watchList = [];
        for(var i = 0; i < bodyContentObject.watchCount; i++){
            var deviceUUID = this.utility.littleEndianUint8ToUint32([decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++]]);
            var parameterId = this.utility.littleEndianUint8ToUint16([decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++]]);
            var valueOfChange = this.utility.littleEndianUint8ToUint32([decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++]]);
            var relation = decryptedMessageArray[arrayIterator++];
            var eventId = this.utility.littleEndianUint8ToUint16([decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++]]);
            bodyContentObject.watchList.push(
                {
                    deviceUUID: deviceUUID,
                    parameterId: parameterId,
                    valueOfChange: valueOfChange,
                    relation: relation,
                    eventId: eventId
                }
            );
        }
        if(arrayIterator != decryptedMessageArray.length){
            // console.log('here');
            //console.log(arrayIterator);
            //console.log(decryptedMessageArray.length);
            bodyContentObject.packetIntegrity = false;
        }
    }.bind(this);
    this._getEventMasksDeserializer = function(bodyContentObject, decryptedMessageArray)
    {
        logger.log("Messaging._getEventMasksDeserializer() :", "deserializing get event masks packet");

        var arrayIterator = this._headerLength + 3;
        bodyContentObject.maskCount = decryptedMessageArray[arrayIterator++];
        bodyContentObject.maskList = [];
        for(var i = 0; i < bodyContentObject.maskCount; i++){
            var eventId = this.utility.littleEndianUint8ToUint16([decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++]]);
            bodyContentObject.maskList.push(
                {
                    eventId: eventId,
                    isMasked: true,
                }
            );
        }
        if(arrayIterator != decryptedMessageArray.length){
            // console.log('here');
            bodyContentObject.packetIntegrity = false;
        }
    }.bind(this);
    this._getUplinkImitatorsDeserializer = function(bodyContentObject, decryptedMessageArray)
    {
        logger.log("Messaging._getUplinkImitatorsDeserializer() :", "deserializing received packet");

        var arrayIterator = this._headerLength + 3;
        bodyContentObject.imitatorsCount = decryptedMessageArray[arrayIterator++];
        bodyContentObject.imitatorsList = [];
        for(var i = 0; i < bodyContentObject.imitatorsCount; i++){
            var imitatorObject = {eventIdToWatch: 0, commandLength: 0, commandToSend: []};
            imitatorObject.eventIdToWatch = this.utility.littleEndianUint8ToUint16([decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++]]);
            imitatorObject.commandLength = this.utility.littleEndianUint8ToUint16([decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++]]);

            for(var j = 0; j < imitatorObject.commandLength; j++){
                imitatorObject.commandToSend.push(decryptedMessageArray[arrayIterator++]);
            }
            bodyContentObject.imitatorsList.push(imitatorObject);
        }
        if(arrayIterator != decryptedMessageArray.length){
            // console.log('here');
            bodyContentObject.packetIntegrity = false;
        }
    }.bind(this);
    this._readEventNotificationsDeserializer = function(bodyContentObject, decryptedMessageArray)
    {
        logger.log("Messaging._readEventNotificationsDeserializer() :", "deserializing read event notifications packet");

        var arrayIterator = this._headerLength + 3;
        bodyContentObject.notificationsCount = decryptedMessageArray[arrayIterator++];
        bodyContentObject.notificationsList = [];
        for(var i = 0; i < bodyContentObject.notificationsCount; i++){
            var eventId = this.utility.littleEndianUint8ToUint16([decryptedMessageArray[arrayIterator++], decryptedMessageArray[arrayIterator++]]);
            bodyContentObject.notificationsList.push(
                {
                    eventId: eventId,
                    isNotified: true,
                }
            );
        }
        if(arrayIterator != decryptedMessageArray.length){
            // console.log('here');
            bodyContentObject.packetIntegrity = false;
        }
    }.bind(this);
    
    
    
    
    
    
    


    this.utility = function(){}.bind(this);
    this.utility.uuidToHexString = function (uuid) {
        logger.log("Messaging.utility.uuidToHexString() :", "converting uuid to hex string with length 8");

        var hexString = uuid.toString(16);
        var zeroCount = 8 - hexString.length;

        for(var i = 0; i < zeroCount; i++){
            hexString = "0" + hexString;
        }
        return hexString;
    }
    this.utility.generateRandomPSK = function()
    {
        var newPSK = new Uint8Array(32);
        window.crypto.getRandomValues(newPSK);

        logger.log("Messaging.utility.generateRandomPSK() :", "generating random psk: " + newPSK);

        return Array.from(newPSK);
    }.bind(this);

    this.utility.generatePskFromPassword = function(password)
    {
        var newPSK = new Uint8Array(32);

        for(var i = 0; i < password.length; i++){
            newPSK[i] = password.charCodeAt(i);
        }
        if(password.length > 0){
            newPSK[i] = 0x00;
        }

        return Array.from(newPSK);
    }.bind(this);

    this.utility.uint32ToLittleEndianUint8 = function(uint32Var)
    {
        logger.log("Messaging.utility.uint32ToLittleEndianUint8() :", "converting uint32 to little endian uinat8array");

        var littleEndianUint8Array = new Uint8Array(4);
        littleEndianUint8Array[0] = uint32Var & 0xFF;
        littleEndianUint8Array[1] = (uint32Var >> 8) & 0xFF;
        littleEndianUint8Array[2] = (uint32Var >> 16) & 0xFF;
        littleEndianUint8Array[3] = (uint32Var >> 24) & 0xFF;

        return littleEndianUint8Array;
    }.bind(this);

    this.utility.littleEndianUint8ToUint32 = function(littleEndianArray)
    {
        logger.log("Messaging.utility.uint32ToLittleEndianUint8() :", "converting uint32 to little endian uinat8array");

        var littleEndianUint8Array = littleEndianArray[0];
        littleEndianUint8Array |= (littleEndianArray[1] << 8);
        littleEndianUint8Array |= (littleEndianArray[2] << 16);
        littleEndianUint8Array |= (littleEndianArray[3] << 24);

        return littleEndianUint8Array;
    }.bind(this);

    this.utility.uint16ToLittleEndianUint8 = function(uint16Var)
    {
        logger.log("Messaging.utility.uint16ToLittleEndianUint8() :", "converting uint16 to little endian uinat8array");

        var littleEndianUint8Array = new Uint8Array(2);
        littleEndianUint8Array[0] = uint16Var & 0xFF;
        littleEndianUint8Array[1] = (uint16Var >> 8) & 0xFF;

        return littleEndianUint8Array;
    }.bind(this);

    this.utility.littleEndianUint8ToUint16 = function(littleEndianArray)
    {
        logger.log("Messaging.utility.littleEndianUint8ToUint16() :", "converting uint16 to little endian uinat8array");
        var littleEndianUint8Array = littleEndianArray[0];
        littleEndianUint8Array |= (littleEndianArray[1] << 8);

        return littleEndianUint8Array;
    }.bind(this);


    this.utility.stringToNullTerminatedArray = function(inputString)
    {
        logger.log("Messaging.utility.stringToNullTerminatedArray() :", "converting string to null terminated array");

        var nullTerminatedArray = [];
        for(var i = 0; i < inputString.length; i++){
            nullTerminatedArray.push( inputString.charCodeAt(i) );
        }
        if(inputString.length < 32){
            nullTerminatedArray.push(0x00);
        }

        return nullTerminatedArray;
    }.bind(this);

    this.utility.stripArrayZeros = function (inputArray) {
        for(var i = inputArray.length; i >= 0; i--){
            if(inputArray[i]){
                break;
            }
        }
        inputArray.splice(i+1);
    }

    this.utility.arrayTo128 = function(inputArray)
    {
        logger.log("Messaging.utility.arrayTo128() :", "converting array to an array with length of 128");

        var outputArray = [];
        var inputArrayLength = inputArray.length;
        for(var i = 0; i < 128; i++){
            if(i < inputArrayLength){
                outputArray.push(inputArray[i]);
            }else{
                outputArray.push(0x00);
            }
        }
        return outputArray;
    }.bind(this);

    this.utility.arrayTo64 = function(inputArray)
    {
        logger.log("Messaging.utility.arrayTo64() :", "converting array to an array with length of 64");

        var outputArray = [];
        var inputArrayLength = inputArray.length;
        for(var i = 0; i < 64; i++){
            if(i < inputArrayLength){
                outputArray.push(inputArray[i]);
            }else{
                outputArray.push(0x00);
            }
        }
        return outputArray;
    }.bind(this);

    this.utility.resolveParameterLength = function(parameterId)
    {
        var parameterLength = Math.pow(2, ((parameterId & this.PARAM_ID_LENGTH_MASK) >> 8));
        logger.log("Messaging.utility.resolveParameterLength() :", "parameter id : " + parameterId + " has length of : " + parameterLength);

        return parameterLength;
    }.bind(this);



    this.irf = function(){}.bind(this);
    this.irf.NUMBER_OF_FINAL_BYTE_STREAM = 128;
    this.irf.generateIrfByteStream = function (raw_ir_data_buffer) {
        var raw_ir_data_counter = raw_ir_data_buffer.length;
        if(raw_ir_data_buffer.length % 2){
            raw_ir_data_buffer.push(0);
        }
        var meaningful_pair_array = [];
        var number_of_meaningful_pair = 0;
    
        number_of_meaningful_pair = this.irf._extract_meaningful_pair(raw_ir_data_buffer, raw_ir_data_counter, meaningful_pair_array);
        console.log(number_of_meaningful_pair);
        this.irf._sort_descending_meaningful_pair(meaningful_pair_array, number_of_meaningful_pair);
        return this.irf._encode_raw_ir_data(raw_ir_data_buffer, raw_ir_data_counter, meaningful_pair_array, number_of_meaningful_pair);
    }.bind(this);

    this.irf._extract_meaningful_pair = function (raw_data, raw_data_counter, meaningful_pair_array) {
        var meaningful_pair_counter = 0;
        var current_pair_index;
        var single_meaningful_pair = {
            pulse_width_us: 0,
            space_width_us: 0,
            counter: 0,
        };
        for (var i = 0; i < raw_data_counter; i += 2) {
            single_meaningful_pair.pulse_width_us = raw_data[i];
            single_meaningful_pair.space_width_us = raw_data[i + 1];
            current_pair_index = this.irf._find_meangful_pair_in_meaningful_pair_array(meaningful_pair_array, single_meaningful_pair, meaningful_pair_counter);
            if (current_pair_index >= 0) {
                this.irf._update_pulse_space_of_meaningful_pair(meaningful_pair_array, current_pair_index, single_meaningful_pair);
                meaningful_pair_array[current_pair_index].counter++;
            } else {
                if(meaningful_pair_array[meaningful_pair_counter] === undefined){
                    meaningful_pair_array[meaningful_pair_counter] = {};
                    meaningful_pair_array[meaningful_pair_counter].counter = 0;
                }
                meaningful_pair_array[meaningful_pair_counter].pulse_width_us = single_meaningful_pair.pulse_width_us;
                meaningful_pair_array[meaningful_pair_counter].space_width_us = single_meaningful_pair.space_width_us;
                meaningful_pair_array[meaningful_pair_counter].counter++;
                meaningful_pair_counter++;
            }
        }
        return meaningful_pair_counter;
    }.bind(this);

    this.irf._find_meangful_pair_in_meaningful_pair_array = function (meaningful_pair_array, single_meaningful_pair, meaningful_pair_counter) {
        var threshold;
        if (0 == meaningful_pair_counter) {
            return -1;
        }
        for (var i = 0; i < meaningful_pair_counter; i++) {
            threshold = this.irf._find_meaningful_pair_threshold(meaningful_pair_array[i]);
            if (
                single_meaningful_pair.pulse_width_us >= threshold.pulse_down_threshold && 
                single_meaningful_pair.pulse_width_us <= threshold.pulse_up_threshold && 
                single_meaningful_pair.space_width_us >= threshold.space_down_threshold && 
                single_meaningful_pair.space_width_us <= threshold.space_up_threshold
            ) {
                return i;
            }
        }
        return -1;
    }.bind(this);

    this.irf._find_meaningful_pair_threshold = function (meaningful_pair) {
        var threshold = {
            pulse_up_threshold: 0,
            pulse_down_threshold: 0,
            space_up_threshold: 0,
            space_down_threshold: 0,
        };
        var pulse_coeff_threshold;
        var space_coeff_threshold;
        if (meaningful_pair.pulse_width_us < 400) {
            pulse_coeff_threshold = 25;
        }
        else if (meaningful_pair.pulse_width_us >= 400 && meaningful_pair.pulse_width_us <= 700) {
            pulse_coeff_threshold = 20;
        }
        else if (meaningful_pair.pulse_width_us > 700 && meaningful_pair.pulse_width_us <= 1200) {
            pulse_coeff_threshold = 15;
        }
        else if (meaningful_pair.pulse_width_us > 1200) {
            pulse_coeff_threshold = 10;
        }
    
        if (meaningful_pair.space_width_us < 400) {
            space_coeff_threshold = 25;
        }
        else if (meaningful_pair.space_width_us >= 400 && meaningful_pair.space_width_us <= 700) {
            space_coeff_threshold = 20;
        }
        else if (meaningful_pair.space_width_us > 700 && meaningful_pair.space_width_us <= 1200) {
            space_coeff_threshold = 15;
        }
        else if (meaningful_pair.space_width_us > 1200) {
            space_coeff_threshold = 10;
        }
    
        threshold.pulse_up_threshold = meaningful_pair.pulse_width_us + Math.floor(((meaningful_pair.pulse_width_us * pulse_coeff_threshold) / 100));
        threshold.pulse_down_threshold = meaningful_pair.pulse_width_us - Math.floor(((meaningful_pair.pulse_width_us * pulse_coeff_threshold) / 100));
    
        threshold.space_up_threshold = meaningful_pair.space_width_us + Math.floor(((meaningful_pair.space_width_us * space_coeff_threshold) / 100));
        threshold.space_down_threshold = meaningful_pair.space_width_us - Math.floor(((meaningful_pair.space_width_us * space_coeff_threshold) / 100));
    
        return threshold;
    }.bind(this);

    this.irf._update_pulse_space_of_meaningful_pair = function (meaningful_pair_array, pair_index, single_meaningful_pair) {
        meaningful_pair_array[pair_index].pulse_width_us = Math.floor((meaningful_pair_array[pair_index].pulse_width_us * meaningful_pair_array[pair_index].counter + single_meaningful_pair.pulse_width_us) / ((meaningful_pair_array[pair_index].counter + 1)));
        meaningful_pair_array[pair_index].space_width_us = Math.floor((meaningful_pair_array[pair_index].space_width_us * meaningful_pair_array[pair_index].counter + single_meaningful_pair.space_width_us) / ((meaningful_pair_array[pair_index].counter + 1)));
    }.bind(this);

    this.irf._sort_descending_meaningful_pair = function (meaningful_pair_array, number_of_meaningful_pair) {
        var temp;
        for (var i = 0; i < number_of_meaningful_pair; i++) {
            for (var j = i + 1; j < number_of_meaningful_pair; j++) {
                if (meaningful_pair_array[i].counter < meaningful_pair_array[j].counter) {
                    temp = meaningful_pair_array[j];
                    meaningful_pair_array[j] = meaningful_pair_array[i];
                    meaningful_pair_array[i] = temp;
                }
            }
        }
    }.bind(this);

    this.irf._encode_raw_ir_data = function (ir_raw_data, size_of_ir_raw_data, meaningful_pair_array, number_of_meaningful_pair) {
        var final_address = 0;
        var final_stream_byte = [];
        //Clear all data in final_stream_byte
        // for(var i = 0; i < this.irf.NUMBER_OF_FINAL_BYTE_STREAM; i++) {
        //     final_stream_byte[i] = 0;
        // }
        //Assign number of raw ir data in 2 first bytes of byte stream
        final_stream_byte[final_address] = size_of_ir_raw_data & 0xFF;
        final_stream_byte[final_address + 1] = (size_of_ir_raw_data >> 8) & 0xFF;
        // this.utility.uint16ToLittleEndianUint8(size_of_ir_raw_data, final_stream_byte + final_address);
        final_address += 2;
    
        //Assign number of meaningful pair in third byte of final byte stream
        final_stream_byte[final_address++] = number_of_meaningful_pair;
    
        //Assign meaningful pair to final byte stream
        for (var j = 0; j < number_of_meaningful_pair; j++) {
            // this.utility.uint16ToLittleEndianUint8(meaningful_pair_array[j].pulse_width_us, final_stream_byte + final_address);
            final_stream_byte[final_address] = meaningful_pair_array[j].pulse_width_us & 0xFF;
            final_stream_byte[final_address + 1] = (meaningful_pair_array[j].pulse_width_us >> 8) & 0xFF;
            final_address += 2;
    
            // this.utility.uint16ToLittleEndianUint8(meaningful_pair_array[j].space_width_us, final_stream_byte + final_address);
            final_stream_byte[final_address] = meaningful_pair_array[j].space_width_us & 0xFF;
            final_stream_byte[final_address + 1] = (meaningful_pair_array[j].space_width_us >> 8) & 0xFF;
            final_address += 2;
        }
    
        var bit_number = final_address * 8;
        var current_pair_index;
        var single_meaningful_pair = {
            pulse_width_us: 0,
            space_width_us: 0,
            counter: 0,
        };
        //Encode meaningful pair and assign to final byte stream
        for (var i = 0; i < size_of_ir_raw_data; i += 2) {
            single_meaningful_pair.pulse_width_us = ir_raw_data[i];
            single_meaningful_pair.space_width_us = ir_raw_data[i + 1];
            current_pair_index = this.irf._find_meangful_pair_in_meaningful_pair_array(meaningful_pair_array, single_meaningful_pair, number_of_meaningful_pair);
            bit_number += current_pair_index;
            this.irf._set_ith_bit(final_stream_byte, bit_number, 1);
            bit_number++;
        }
        return final_stream_byte;
    }.bind(this);

    this.irf._set_ith_bit = function (array, bit_number, value) {
        var mask = 0;
        var bit_number_divided_by_8 = Math.floor(bit_number / 8);
        mask = 1 << (7 - (bit_number % 8));
        if (value == 1) {
            array[bit_number_divided_by_8] = array[bit_number_divided_by_8] | mask;
        } else {
            array[bit_number_divided_by_8] = array[bit_number_divided_by_8] & ~mask;
        }
    }.bind(this);

    this.irf.generateRawData = function (binaryData, lowThrUs, highThrUs, startSeq, endSeq) {
        var rawData = [];
        rawData.push(startSeq[0]);
        rawData.push(startSeq[1]);
        binaryData.forEach(data => {
            if(data){
                rawData.push(highThrUs);
                rawData.push(lowThrUs);
            }else{
                rawData.push(lowThrUs);
                rawData.push(highThrUs);
            }
        })
        if(endSeq[0]){
            rawData.push(endSeq[0]);
        }
        if(endSeq[1]){
            rawData.push(endSeq[1]);
        }
        // console.log(rawData);
        return rawData;
    }.bind(this);
}